import React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';

import { useGroupedFleets } from '../../hooks';

interface Props {
  setSelectedFleetId: (id: string) => void;
  selectedFleetId: string;
}

export function MigrateFleetsDropdown(props: Props) {
  const { setSelectedFleetId, selectedFleetId } = props;
  const { groupedFleets } = useGroupedFleets();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedFleetId(e.target.value);
  };

  return (
    <FormGroup>
      <FormControl as="select" data-test="fleet-menu" onChange={handleChange} custom value={selectedFleetId}>
        {Object.keys(groupedFleets).map((groupName) => (
          <optgroup key={groupName} label={groupName}>
            {groupedFleets[groupName].map((item) => (
              <option key={item?.id} value={item?.uuid}>
                {item.display_name}
              </option>
            ))}
          </optgroup>
        ))}
      </FormControl>
    </FormGroup>
  );
}
